import _ from 'lodash'
import { PREFERENCE_STORE_REQ } from './column-preference.type'

const state = {
  userPref: {}
}

const getters = {
  userPref: state => state.userPref
}

const mutations = {
  [PREFERENCE_STORE_REQ]: (state, data) => {
    if (_.has(state.userPref, data.userId)) {
      state.userPref[data.userId][data.tblName] = data.preferedCols
    } else {
      state.userPref = {
        [data.userId]: {
          [data.tblName]: data.preferedCols
        }
      }
    }
  }
}

const actions = {
  [PREFERENCE_STORE_REQ] (context, data) {
    context.commit(PREFERENCE_STORE_REQ, data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/column-preference/column-preference.module.js